import { lazyPage } from '@/lib/lazy-load'

const MyTrashPage = lazyPage(() => import('./MyTrashPage'))
export default MyTrashPage
